<template>
  <div class="my">
    <img class="my_img" src="static/images/per_01.png" alt="">
    <div class="cont">
      <img class="c1" src="static/images/login_1.png" alt="">
      <div class="c2"><input class="phone" type="text" placeholder="请输入手机号" v-model="phone" maxlength="11"></div>

      <div class="c3 img_box">
        <input class="code_in" v-model="imgcode" placeholder="请输入图形验证码">
        <img class="img_code" id="imgCode" :src="imgUrl" @click="handleClick">
      </div>

      <div class="c3 code_box"><input class="code" v-model="code" placeholder="请输入短信验证码"><span class="c41" :class="{'active': iscl && imgcode}" @click="set()">获取验证码</span></div>

      <div class="c3"><input class="pass" type="password" placeholder="请输入密码" v-model="pass" maxlength="15"></div>
      <div class="me"></div>
      <div class="lo" @click="lo()" :class="mode?'active':''">登&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp录</div>
      <div class="c4"><u class="u1" @click="password()">忘记密码？</u><u class="u2" @click="register()">立即注册</u></div>
      <div class="c5">————————其他登录方式————————</div>
      <div class="c6">
        <a href="http://bjmuseum.org.cn/admin/m/wxLogin.do"><img src="static/images/weixin.svg" alt=""></a>
        <!-- <a href="http://test.tj720.com/admin/m/wxLogin.do"><img src="static/images/weixin.svg" alt=""></a> -->
        <a href="http://test.tj720.com/admin/qq.do" style="display:none;"><img  src="static/images/qq.svg" alt=""></a>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {api} from '../global/api';
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import md5 from 'js-md5';
  import qs from 'qs';
  // import hex_md5 from '../../static/js/md5.js'
    export default {
      name: "login",
      data () {
        return {
          isMobile:/^1[3578]\d{9}$|^147\d{8}$/,       //手机号码验证规则
          // ispass:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/, //密码验证 6-10位
          phone:"",
          pass:"",
          imgcode: "",
          code: "",
          sucode:"",
          isph:false,
          ispa:false,
          iscl:false,
          count:5,
          imgUrl: '/admin/getImgCode.do'
        }
      },
      computed:{
        mode:function () {
        return  this.isph && this.pass && this.imgcode && this.code
        // return  this.isph&&this.ispa
        }
      },
      methods:{
        handleClick() {
          this.imgUrl = '/admin/getImgCode.do?' + Math.random()
        },
        lo(){
          var _this = this;
          if(!$('.lo').hasClass("active")){
            return false;
          }
          // else if(!(_this.isph&&_this.ispa)){
          //   $('.me').text("用户名和密码不正确！");
          //   return false;
          // }
          else{
            // var params={phone:document.getElementsByClassName("phone")[0].value,password:md5(document.getElementsByClassName("pass")[0].value),rpassword:btoa(document.getElementsByClassName("pass")[0].value)};
            console.log(this)
            var params={
              phone:document.getElementsByClassName("phone")[0].value,
              password:this.$getRsaCode(document.getElementsByClassName("pass")[0].value),
              secretCode: this.code,
              token: this.sucode
            };
            this.$http.post(api.login,
              params,
              {
                emulateJSON: true
              }).then(response  => {
              if(response.data.success==1){
                localStorage['userid']=response.data.data.id;
                localStorage['token']=response.data.data.token;
                _this.$router.push({ path: '/my'})
              }else{
                $('.me').text(response.data.data.tipMessage);
              }
            })
          }
        },
        register(){
          this.$router.push({ path: 'register'})
        },
        password(){
          this.$router.push({ path: 'resetPass'})
        },
        jianting(){
          var _this=this;
          $('.phone').bind('input propertychange', function() {
            _this.phone=$('.phone').val();
            $('.me').text("");
            if(!_this.isMobile.test(_this.phone)){
              _this.iscl=false;
              // if(!$('.c41').hasClass("active")){
              //   $('.c41').addClass("active");
              // }
            }else if(_this.isMobile.test(_this.phone)){
              $('.me').text("");
              _this.iscl=true;
              // $('.c41').removeClass("active");
            }
          })
          
          $('.phone').bind('input propertychange', function() {
            _this.phone=$('.phone').val();
            $('.me').text("");
            if(_this.isMobile.test(_this.phone)){
              _this.isph=true;
            }else if(_this.phone.length==11){
              $('.me').text("请输入正确的手机号！");
            }else{
              $('.me').text("请输入正确的手机号！");
              _this.isph=false;
            }
            console.log( _this.isph)
          })

          $('.code_in').bind('input propertychange', function() {
            _this.imgcode=$('.code_in').val();
            $('.me').text("");
            if(_this.imgcode){
              _this.isph=true;
            }else{
              $('.me').text("请输入图形验证码");
              _this.isph=false;
            }
          })

          $('.code_in').bind('input propertychange', function() {
            _this.imgcode=$('.code_in').val();
            $('.me').text("");
            if(_this.imgcode){
              _this.isph=true;
            }else{
              $('.me').text("请输入图形验证码");
              _this.isph=false;
            }
          })
          // $('.pass').bind('input propertychange', function() {
          //   _this.pass=$('.pass').val();
          //   $('.me').text("");
          //   console.log(_this.pass,_this.ispass.test(_this.pass));
          //   if(_this.ispass.test(_this.pass)){
          //     _this.ispa=true;
          //     $('.lo').addClass("active");
          //   }else if(_this.pass.length==10){
          //     $('.me').text("密码长度限制在10位！");
          //   }else{
          //     $('.me').text("请输入正确的密码！");
          //     _this.ispa=false;
          //     /*if($('.lo').hasClass("active")){
          //       $('.lo').removeClass("active");
          //     }else{
          //       $('.lo').addClass("active");
          //     }*/
          //   }
          //   console.log( _this.ispa)
          // })
        },
        set(){
          var _this=this;
          if(this.iscl){
            this.timeDown();
            console.log(this.phone);
            this.$http.post('/admin/login/sendCode.do', {
              phone: this.phone,
              code: this.imgcode
            },{
              emulateJSON: true
            }).then(response  => {
              console.log(response);
              if(response.body.success==1){
                _this.isco=true;
                _this.sucode=response.body.others;
              }else{
                $('.me').text(response.body.data);
                this.handleClick()
              }
            })
          }else{
            $('.me').text("请输入正确的手机号");
          }
        },
        // time(){
        //   this.count--;
        //   if(this.count==0){
        //     this.iscl=true;
        //     this.count=60;
        //     $('.c41').text("获取手机验证码");
        //     return false;
        //   }else{
        //     this.iscl=false;
        //     $('.c41').text(this.count+"秒后重新发送");
        //   }
        //   setTimeout(this.time,1000);
        // },
        timeDown() {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.iscl=false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                $('.c41').text(this.count+"秒后重新发送");
                this.count--;
              } else {
                this.iscl=true;
                $('.c41').text("获取手机验证码");
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        },
        weixin(){
          this.$http.get(api.weixin).then(response  => {
            /*if(response.data.success==1){
              console.log(1);
              localStorage['userid']=response.data.data.id;
              //this.$router.push({ path: 'my'})
            }else{
              $('.me').text(response.data.tipMessage)
            }*/
            console.log(response);
          })
        },
        qq(){
          var _this = this;
          $.ajax({
            type:"get",
            url:api.qq,
            async:true,
            dataType:'jsonp',
//          		crossDomain:true,
            success:function(data){
              console.log(data);
              window.location.href = data;
            }
          });
        }
      },
      mounted(){
        this.jianting();
      },
      beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
      }
    }
</script>

<style scoped>
  input{
    border: none;
    outline: none;
    background-color: rgba(241, 241, 242, 1);
    font-size: 14px;
    height: 1.5rem;
    line-height: 1.5rem;
    position: absolute;
    top: 50%;
    left: 2.35rem;
    transform: translateY(-50%);
    padding: 0;

  }
  .my{
    height: 100%;
    width: 100%;
    background-color: rgba(241, 241, 242, 1);
    overflow-x: hidden;
  }
  .my_img{
    width: 100%;
    display: inline-block;
    position: relative;
    z-index: 10;
  }
  .cont{
    padding-top: 2rem;
    margin: -11.25rem auto 7rem;
    width: 17.25rem;
    height: 23.1rem;
    border-radius: 0.4rem;
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    z-index: 20;
  }
  .c1{
    display: block;
    margin: 0 auto;
    width: 8rem;
  }
  .c2{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 8px;
    background: rgb(241,241,241) url("../../static/images/login_2.svg") no-repeat 0.65rem 0.4rem;
    background-size: 1rem 1rem;
    margin: 2.1rem auto 0;
    position: relative;
  }
  .c3{
    width: 15.75rem;
    height: 1.8rem;
    border-radius: 8px;
    background: rgb(241,241,241) url("../../static/images/login_3.svg") no-repeat 0.65rem 0.4rem;
    background-size: 1rem 1rem;
    margin: 0.5rem auto 0;
    position: relative;
    
  }
  .c3.img_box {
    /* background: rgb(241,241,241) url("../../static/images/login_4.svg") no-repeat 0.65rem 0.4rem; */
    background-size: 1rem 1rem;
  }
  .c3.code_box {
    /* background: rgb(241,241,241) url("../../static/images/login_5.svg") no-repeat 0.65rem 0.4rem; */
    background-size: 1rem 1rem;
  }
  .lo{
    margin: 0.5rem auto 0;
    width: 15.75rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.4rem;

    text-align: center;
    color: #999;
    font-size: 0.7rem;
    display: block;
    border: none;
    outline:none;
    color: #999;
    background-color: #d8d8d8;
  }
  .lo.active{
    color: #fff;
    background-color: rgba(196, 77, 65, 1);
  }
  .c4{
    width: 15.75rem;
    margin: 0.5rem auto 0;
  }
  .u1{
    display: inline-block;
    float: left;
    color: rgb(153,153,153);
    font-size: 12px;
  }
  .u2{
    display: inline-block;
    float: right;
    color: rgb(196,77,65);
    font-size: 12px;
  }
  .c5{
    font-size: 12px;
    color: rgb(153,153,153);
    text-align: center;
    margin-top: 2.4rem;
    margin-bottom: 1rem;
  }
  .c6{
    width: 8.3rem;
    margin: 0 auto;
    text-align: center;
  }
  .c6 img{
    width: 2.4rem;
    height: 2.4rem;
  }
  .c6 img:nth-child(2){
    margin-left: 3.5rem;
  }
  .me{
    font-size: 12px;
    color: #c44d41;
    margin: 0.5rem auto 0;
    width: 15.75rem;
    height: 12px;
  }

  .c41{
    font-size: 0.7rem;
    color: rgb(153,153,153);
    float: right;
    height: 1.8rem;
    line-height: 1.8rem;
    margin-right: 0.5rem;
  }
  .c41.active{
    color: rgb(196,77,65);
  }

  .img_code{
    font-size: 0.7rem;
    color: rgb(196,77,65);
    float: right;
    height: 1.8rem;
    line-height: 1.8rem;
    /* margin-top: 0.15rem;
    margin-right: 0.5rem; */
  }
  /* .img_code.active{
    color: rgb(153,153,153);
  } */
</style>




// WEBPACK FOOTER //
// src/view/login.vue